var _style, _g, _g2, _path, _path2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 292.6 181.68",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#005253;}\n\t.st2{fill:#041615;}\n\t.st3{fill:#508E8E;}\n\t.st4{fill:#8EB2B1;}\n\t.st5{fill:#6B7574;}\n\t.st6{fill:#A6ADAC;}\n\t.st7{fill:#EDF4F3;}\n\t.st8{fill:#0C3233;}\n\t.st9{fill:#3B4241;}\n\t.st10{fill:#EA7363;}\n\t.st11{fill:#EFA29A;}\n\t.st12{fill:#F7CDCB;}\n\t.st13{fill:#E5372E;}\n\t.st14{fill:#00D061;}\n\t.st15{fill:#EFC820;}\n\t.st16{fill:#27D6B4;}\n\t.st17{fill:#04826A;}\n\t.st18{fill:#68EAD1;}\n\t.st19{fill:#06A6B7;}\n\t.st20{fill:#50D3DD;}\n\t.st21{fill:#98EFF4;}\n\t.st22{fill:#FFEBE9;}\n\t.st23{fill:#CDF7EF;}\n\t.st24{fill:#06B594;}\n\t.st25{fill:#D7FFFF;}\n\t.st26{opacity:0.4;fill:#FFFFFF;}\n\t.st27{fill:url(#SVGID_1_);}\n\t.st28{fill:url(#SVGID_2_);}\n\t.st29{fill:url(#SVGID_3_);}\n\t.st30{fill:url(#SVGID_4_);}\n\t.st31{fill:url(#SVGID_5_);}\n\t.st32{fill:url(#SVGID_6_);}\n\t.st33{fill:#05A5B5;}\n\t.st34{fill:#27BAA5;}\n\t.st35{fill:url(#SVGID_7_);}\n\t.st36{fill:url(#SVGID_8_);}\n\t.st37{fill:none;stroke:#8EB2B1;stroke-width:0.5;stroke-linejoin:round;}\n\t.st38{fill:none;stroke:#8EB2B1;stroke-width:0.5;stroke-linejoin:round;stroke-dasharray:2.002,3.003;}\n\t.st39{fill:none;stroke:#005253;stroke-width:0.5;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.6,53.07c-23.58-23.58-61.82-23.58-85.41,0c-23.58,23.58-23.58,61.82,0,85.41 c42.7,42.7,128.11,42.7,128.11,42.7S146.3,95.77,103.6,53.07z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 60.89,
    cy: 95.77,
    r: 15.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M146.3,0c-33.35,0-60.39,27.04-60.39,60.39c0,60.39,60.39,120.78,60.39,120.78s60.39-60.39,60.39-120.78 C206.69,27.04,179.65,0,146.3,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 146.3,
    cy: 60.39,
    r: 15.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M274.41,53.07c-23.58-23.58-61.82-23.58-85.41,0c-42.7,42.7-42.7,128.11-42.7,128.11s85.41,0,128.11-42.7 C298,114.89,298,76.65,274.41,53.07z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 231.71,
    cy: 95.77,
    r: 15.1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 148.2831,
    cy: 191.833,
    r: 166.9783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3334,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6709,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M88.72,42.16c-1.82,5.75-2.81,11.88-2.81,18.23c0,60.39,60.39,120.78,60.39,120.78s0-85.41-42.7-128.11 C99.1,48.57,94.07,44.94,88.72,42.16z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 143.7373,
    cy: 184.0126,
    r: 168.0566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3334,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7013,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M203.88,42.16c-5.36,2.78-10.39,6.41-14.88,10.91c-42.7,42.7-42.7,128.11-42.7,128.11 s60.39-60.39,60.39-120.78C206.69,54.04,205.7,47.91,203.88,42.16z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolks);
export default __webpack_public_path__ + "static/media/folks.26c79e5fc5ed8c44f3095b2855e837ab.svg";
export { ForwardRef as ReactComponent };